/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Grid, styled, Typography, Tab } from "@mui/material";
import React, { useState } from "react";
import { fonts, themes } from "../../../common/themes/themes";
import { useAppSelector } from "../../../infra/hooks";
import "./Training.css";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import TablistingBox from "../../../common/components/TablistingBox/TablistingBox";
import MyTrainingController from "../../../domain/myProfile/training/MyTraining/MyTrainingController";
import EmpTrainingController from "../../../domain/myProfile/training/EmployeeTraining/EmpTrainingController";

const CustomTabList = styled(TabList)(() => ({
  "& .Mui-selected": {
    textTransform: "capitalize",

    color: "#7C0E6F",
  },
  "& .css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected": {
    color: "#7C0E6F",
  },
  "& .MuiButtonBase-root": {
    textTransform: "capitalize",
    fontWeight: "bold",
  },
  "& .css-1aquho2-MuiTabs-indicator": {
    backgroundColor: "#7C0E6F",
  },
}));
interface propTraining {
  trans?: any;
  i18n?: any;
}

const TrainingPresenter = ({ trans, i18n }: propTraining) => {
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);

  const [selectedTab, setSelectedTab] = useState("mytraining");

  return (
    <Grid
      container
      style={{
        display: "flex",
        flexWrap: "nowrap",
        marginTop: isHRView ? "" : "4em",
        width: "100vw",
        paddingRight: "8em",
      }}
    >
      <Grid
        item
        xs={11}
        sm={11}
        md={11}
        lg={11}
        sx={{
          backgroundColor: "#F5F5FA",
          width: "100%",
          padding: "1.75em",
          marginLeft:
            isHRView && i18n.language == "en"
              ? "11em"
              : !isHRView && i18n.language == "en"
              ? "14em"
              : "",
          marginRight: i18n.language == "ar" ? "15em" : "",
        }}
      >
        <Grid
          container
          style={{
            paddingLeft: isHRView ? "2em" : "",
          }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={{
              width: "100%",
              height: "80px",
            }}
          >
            <Grid
              container
              style={{
                width: "auto",
                background: "#FFFFFF 0% 0% no-repeat padding-box",
                borderRadius: "10px",
                opacity: "1",
                display: "flex",
                flexDirection: "row",
                paddingTop: "1em",
                paddingBottom: "1em",
                paddingLeft: "1em",
                paddingRight: "1em",
              }}
            >
              <Grid item xs={9}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.header,
                    color: themes.blackDefault,
                    fontWeight: "bold",
                  }}
                >
                  {trans("Training")}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={{
              width: "100%",
              height: "80px",
            }}
          >
            <Grid
              container
              style={{
                width: "auto",
                background: "#FFFFFF 0% 0% no-repeat padding-box",
                borderRadius: "10px",
                opacity: "1",
                display: "flex",
                flexDirection: "row",
                paddingTop: "1em",
                paddingBottom: "1em",
                paddingLeft: "1em",
                paddingRight: "1em",
              }}
            >
              <Grid item xs={12}>
                <Box
                  sx={{
                    "& .header": {
                      backgroundColor: "#F5F5F5",
                    },
                  }}
                >
                  <TabContext value={selectedTab}>
                    <Box className="tab-headerEmp">
                      <CustomTabList
                        onChange={(event, newValue) => {
                          setSelectedTab(newValue);
                        }}
                      >
                        <Tab
                          label={
                            <React.Fragment>
                              <Typography
                                style={{
                                  fontFamily: "Lato",
                                  color: "#7C0E6F",
                                  fontWeight: "bold",
                                }}
                              >
                                {trans("My Training")}
                              </Typography>
                            </React.Fragment>
                          }
                          value="mytraining"
                          key="mytraining"
                        />

                        <Tab
                          label={
                            <React.Fragment>
                              <Typography
                                style={{
                                  fontFamily: "Lato",
                                  color: "#7C0E6F",
                                  fontWeight: "bold",
                                }}
                              >
                                {trans("Employee Training")}
                              </Typography>
                            </React.Fragment>
                          }
                          value="employeetraining"
                          key="employeetraining"
                        />
                      </CustomTabList>
                    </Box>
                    <TablistingBox title="">
                      <TabPanel value="mytraining">
                        <Grid container style={{ marginTop: "1em" }}>
                          <Grid item xs={12}>
                            <MyTrainingController />
                          </Grid>
                        </Grid>
                      </TabPanel>
                      <TabPanel value="employeetraining">
                        <Grid container style={{ marginTop: "1em" }}>
                          <Grid item xs={12}>
                            <EmpTrainingController />
                          </Grid>
                        </Grid>
                      </TabPanel>
                    </TablistingBox>
                  </TabContext>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default TrainingPresenter;
